<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        series: [
          {
            type: "funnel",
            data: [
              { value: 60, name: "Visit" },
              { value: 40, name: "Inquiry" },
              { value: 20, name: "Order" },
              { value: 80, name: "Click" },
              { value: 100, name: "Show" }
            ]
          }
        ]
      }
    };
  }
};
</script>
